import { z } from "zod";
import { createTRPCRouter, protectedProcedure, publicProcedure } from "../trpc";
import { TRANSACTION_TYPE } from "@prisma/client";
import { sortByNepaliDate } from "../utils";

export const otherRouter = createTRPCRouter({
    getOtherTable: protectedProcedure
        .query(async ({ ctx }) => {
            const response = await ctx.prisma.transaction.findMany({
                where: {
                    type: TRANSACTION_TYPE.OTHER,
                    isActive: true
                },
                include: {
                    other: {
                        select: { id: true }
                    }
                }
            });

            const sortedResponse = response.sort(sortByNepaliDate)
            const others = sortedResponse.map((txn) => ({
                id: txn.other?.id,
                ...txn,
                income: undefined
            }));

            return others;
        }),

    // getOtherById: publicProcedure
    //     .input(z.object({
    //         id: z.number()
    //     }))
    //     .query(async ({  input }) => {
    //         const other = await ctx.prisma.transaction.findUnique({
    //             where: {
    //                 id: input.id,
    //                 type: TRANSACTION_TYPE.OTHER
    //             }
    //         });
    //
    //         return other;
    //     }),

    createOther: publicProcedure
        .input(
            z.object({
                day: z.coerce.number().nullable(),
                month: z.string().min(1, "Month is required"),
                year: z.coerce.number().min(1, "Year is required"),
                billNo: z.string().nullable(),
                purpose: z.string().min(1, "Purpose is required"),
                method: z.string().min(1, "Method is required"),
                amount: z.coerce.number().min(-99999999, "Amount is required"),
                remark: z.string().optional(),
            })
        )
        .mutation(async ({ ctx, input }) => {
            const newOther = await ctx.prisma.transaction.create({
                data: {
                    ...input,
                    type: TRANSACTION_TYPE.OTHER,
                    isActive: true,
                    other: {
                        create: {}
                    }
                }
            });

            return newOther;
        }),

    updateOtherTable: publicProcedure
        .input(
            z.object({
                transactionId: z.number(),
                day: z.coerce.number().nullable(),
                month: z.string().min(1, "Month is required"),
                year: z.coerce.number().min(1, "Year is required"),
                billNo: z.string().nullable(),
                purpose: z.string().min(1, "Purpose is required"),
                method: z.string().min(1, "Method is required"),
                amount: z.coerce.number().min(-99999999, "Amount is required"),
                remark: z.string().optional(),
            })
        )
        .mutation(async ({ ctx, input }) => {
            const { transactionId, ...data } = input;
            console.log(input)
            const updatedOther = await ctx.prisma.transaction.update({
                where: {
                    transactionId,
                    type: TRANSACTION_TYPE.OTHER
                },
                data
            });

            return updatedOther;
        }),

    // IF THERE WILL BE NEED FOR THE DELETION
    // WE WILL BE WORKING WITH SOFT DELETE

    // deactivateOther: publicProcedure
    //   .input(z.object({
    //     id: z.number()
    //   }))
    //   .mutation(async ({  ctx, input }) => {
    //     const deactivatedOther = await ctx.prisma.transaction.update({
    //       where: {
    //         id: input.id,
    //         type: TRANSACTION_TYPE.OTHER
    //       },
    //       data: {
    //         isActive: false
    //       }
    //     });
    //     
    //     return deactivatedOther;
    //   }),

    // reactivateOther: publicProcedure
    //   .input(z.object({
    //     id: z.number()
    //   }))
    //   .mutation(async ({ ctx, input }) => {
    //     const reactivatedOther = await ctx.prisma.transaction.update({
    //       where: {
    //         id: input.id,
    //         type: TRANSACTION_TYPE.OTHER
    //       },
    //       data: {
    //         isActive: true
    //       }
    //     });
    //     
    //     return reactivatedOther;
    //   }),
});
